// extracted by mini-css-extract-plugin
export default {"SplitLayout":"SplitLayout_SplitLayout__wQuZH","top":"SplitLayout_top__kH9cz","bottom":"SplitLayout_bottom__sgaw1","line":"SplitLayout_line__fR-33"};